function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1699 3.32184C10.619 2.72277 10.2433 1.94898 10.1682 1.10031V0.750854H9.39177H7.38819V11.6838C7.38819 12.9568 6.33631 13.9802 5.05903 13.9802C4.30769 13.9802 3.63148 13.6307 3.20572 13.0566C2.90519 12.6573 2.72987 12.158 2.72987 11.6588C2.72987 10.3858 3.78175 9.33744 5.05903 9.33744C5.30948 9.33744 5.53488 9.3624 5.76029 9.43728V6.66661C5.48479 6.64165 5.23435 6.61669 4.95885 6.61669C2.22898 6.66661 0 8.9131 0 11.6838C0 13.0566 0.550984 14.3047 1.45259 15.2282C2.37925 16.1768 3.65653 16.7509 5.08408 16.7509C7.88909 16.7509 10.1682 14.4794 10.1682 11.7087V6.09251C11.2451 6.8663 12.5725 7.3156 14 7.3156V4.56989C13.7245 4.56989 13.449 4.54493 13.1986 4.495C13.2236 4.495 12.1467 4.34524 11.1699 3.32184Z",
  fill: "white"
});

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.39d6537d.svg";
export { ForwardRef as ReactComponent };